import { css } from 'emotion'

export const HistoryCardStyles = css``
